export default function ServiceHero() {
  return (
    <section className="relative pt-32 pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B6B]/10 via-white to-[#FAF8F5]"></div>
      
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-block px-4 py-2 bg-[#FF6B6B] text-white text-sm font-semibold rounded-full mb-6">
            Our Services
          </div>
          
          <h1 className="text-6xl md:text-7xl font-bold text-[#1A2332] mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Choose Your Path to<br />Airbnb Success
          </h1>
          
          <p className="text-xl text-gray-600 leading-relaxed mb-12">
            From comprehensive training to full-service management, we offer flexible packages designed to meet your unique needs and help you maximize your property's earning potential.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <a href="#pricing" className="inline-flex items-center bg-[#FF6B6B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#ff5252] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap">
              View Pricing Plans
              <i className="ri-arrow-down-line ml-2"></i>
            </a>
            <a href="#details" className="inline-flex items-center bg-white text-[#1A2332] px-8 py-4 rounded-lg font-semibold border-2 border-[#1A2332] hover:bg-[#1A2332] hover:text-white transition-all cursor-pointer whitespace-nowrap">
              Learn More
              <i className="ri-information-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
